
export default class RenderLoop {
    private _lastRenderTime:number = 0;
    private _totalTime:number = 0;
    private _deltaTime:number = 0;

    private _renderItems:Array<RenderItem> = [];
    private _killItems:Array<RenderItem> = [];

    private static _instance: RenderLoop;
    public static get Instance(): RenderLoop {
        if(this._instance == null) {
            this._instance = new RenderLoop();
            this._instance.render();
        }
        return this._instance;
    }

    public add(renderFunction:(deltaTime: number, totalTime:number) => any, fps:number = 60):RenderItem {
        // console.log('RenderLoop.add();' + renderFunction.toString());

        let renderItem = new RenderItem(renderFunction, fps);
        this._renderItems.push(renderItem);
        return renderItem;
    }

    public remove(renderItem:RenderItem):void {
        // console.log('RenderLoop.remove();');

        this._killItems.push(renderItem);
    }

    private render = () => {
        let currentTime:number = Date.now();
        let timePassed = (currentTime - this._lastRenderTime) / 1000;

        this._lastRenderTime = currentTime;
        this._totalTime += timePassed;
        this._deltaTime = timePassed;

        let l = this._renderItems.length;

        let item:RenderItem;

        // console.log('l : ' + l);

        for(let i = 0; i < l; i += 1) {
            item = this._renderItems[i];
            item.render(this._deltaTime);
        }

        while(this._killItems.length > 0) {
            let index = this._renderItems.indexOf(this._killItems[0]);
            // console.log('index : ' + index);
            if(index !== - 1) {
                this._renderItems.splice(index, 1);
            }
            this._killItems.shift();
        }

        requestAnimationFrame( this.render );
    }
}

export class RenderItem {
    public totalTime:number  = 0;
    public deltaTime:number  = 0;
    public renderFunction:Function;
    private _fps:number;

    constructor(renderFunction:(deltaTime: number, totalTime:number) => any, fps:number) {
        this.renderFunction = renderFunction;
        this._fps = fps;
    }

    public render(deltaTime:number):void {
        this.totalTime += deltaTime;
        this.deltaTime += deltaTime;

        let secondsPerFrame = 1 / this._fps;
        if(this.deltaTime < secondsPerFrame) {
            return;
        }

        this.deltaTime -= secondsPerFrame;
        this.renderFunction(this.deltaTime, this.totalTime);
    }

    public remove():void {
        RenderLoop.Instance.remove(this);
    }
}